module.exports = __webpack_public_path__ + "images/655f44a.jpg";